import { cn } from '@/lib/cn';

interface AnimatedHamburgerProps {
  /** When true, the three bars morph into an X. */
  open: boolean;
  className?: string;
}

/**
 * Three-bar menu icon that animates into an X (and back) using `currentColor`.
 *
 * The bars slide toward the center and rotate into a cross; the middle bar
 * fades out. The long 3s duration is intentional so the motion is clearly
 * visible. Purely decorative — the parent <button> carries the label/state.
 */
export function AnimatedHamburger({ open, className }: AnimatedHamburgerProps) {
  const bar =
    'absolute left-1/2 h-0.5 w-5 -translate-x-1/2 rounded-full bg-current ' +
    'transition-all duration-[400ms] ease-in-out';

  return (
    <span aria-hidden="true" className={cn('relative block h-5 w-5', className)}>
      {/* Top bar → slides down and rotates +45° */}
      <span
        className={cn(bar, open ? 'top-[9px] rotate-45' : 'top-[4px] rotate-0')}
      />
      {/* Middle bar → fades out */}
      <span
        className={cn(bar, 'top-[9px]', open ? 'opacity-0' : 'opacity-100')}
      />
      {/* Bottom bar → slides up and rotates -45° */}
      <span
        className={cn(bar, open ? 'top-[9px] -rotate-45' : 'top-[14px] rotate-0')}
      />
    </span>
  );
}
